import React from 'react';
import { GridToolbarContainer } from '@mui/x-data-grid';
import DataGridColumnReorderButton from '@/components/table/DataGridComponents/DataGridColumnReorderButton';

/**
 * AdminDataGrid's toolbar: the Columns button (unless showColumnsButton is false), then any
 * table-specific actions (e.g. an export button).
 */
export const AdminGridToolbar = ({ actions, showColumnsButton }) => (
	<GridToolbarContainer sx={{ px: 1 }}>
		{showColumnsButton && <DataGridColumnReorderButton />}
		{actions}
	</GridToolbarContainer>
);

AdminGridToolbar.displayName = 'AdminGridToolbar';
